export const getRowId = (originalRow, relativeIndex) => {
    return originalRow.id ? originalRow.id : `${relativeIndex}`;
};
